export default {
  SET_FILTERS: "SET_FILTERS",

  SET_ACTIVE_INSTITUTION: "SET_ACTIVE_INSTITUTION",

  CLOSE_NAV: "CLOSE_NAV",
  TOGGLE_NAV: "TOGGLE_NAV",

  LOGIN: "LOGIN",
  LOGGING_IN: "LOGGING_IN",
  LOGGED_IN: "LOGGED_IN",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGOUT: "LOGOUT",

  SAVE_USER: "SAVE_USER",
  SAVING_USER: "SAVING_USER",
  SAVED_USER: "SAVED_USER",
  SAVE_USER_FAILED: "SAVE_USER_FAILED",

  VALIDATE_REGISTRATION: "VALIDATE_REGISTRATION",
  VALIDATING_REGISTRATION: "VALIDATING_REGISTRATION",
  VALIDATED_REGISTRATION: "VALIDATED_REGISTRATION",
  VALIDATE_REGISTRATION_FAILED: "VALIDATE_REGISTRATION_FAILED",

  RESET_REQUEST_PASSWORD: "RESET_REQUEST_PASSWORD",
  REQUEST_PASSWORD: "REQUEST_PASSWORD",
  REQUESTING_PASSWORD: "REQUESTING_PASSWORD",
  REQUESTED_PASSWORD: "REQUESTED_PASSWORD",

  RESET_RESET_PASSWORD: "RESET_RESET_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESETTING_PASSWORD: "RESETTING_PASSWORD",
  PASSWORD_RESET: "PASSWORD_RESET",
  RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",

  CLEAR_EDIT_USER: "CLEAR_EDIT_USER",

  LOAD_CATEGORIES: "LOAD_CATEGORIES",
  LOADING_CATEGORIES: "LOADING_CATEGORIES",
  LOADED_CATEGORIES: "LOADED_CATEGORIES",

  LOAD_DISTRICTS: "LOAD_DISTRICTS",
  LOADING_DISTRICTS: "LOADING_DISTRICTS",
  LOADED_DISTRICTS: "LOADED_DISTRICTS",

  FETCH_INSTITUTIONS: "FETCH_INSTITUTIONS",
  FETCHING_INSTITUTIONS: "FETCHING_INSTITUTIONS",
  FETCHED_INSTITUTIONS: "FETCHED_INSTITUTIONS",
  FETCH_INSTITUTIONS_FAILED: "FETCH_INSTITUTIONS_FAILED",

  CLEAR_EDIT_INSTITUTION: "CLEAR_EDIT_INSTITUTION",

  FETCH_INSTITUTION: "FETCH_INSTITUTION",
  FETCHING_INSTITUTION: "FETCHING_INSTITUTION",
  FETCHED_INSTITUTION: "FETCHED_INSTITUTION",
  FETCH_INSTITUTION_FAILED: "FETCH_INSTITUTION_FAILED",

  SAVE_INSTITUTION: "SAVE_INSTITUTION",
  SAVING_INSTITUTION: "SAVING_INSTITUTION",
  SAVED_INSTITUTION: "SAVED_INSTITUTION",
  SAVE_INSTITUTION_FAILED: "SAVE_INSTITUTION_FAILED",

  FETCH_USERS: "FETCH_USERS",
  FETCHING_USERS: "FETCHING_USERS",
  FETCHED_USERS: "FETCHED_USERS",
  FETCH_USERS_FAILED: "FETCH_USERS_FAILED",

  FETCH_USER: "FETCH_USER",
  FETCHING_USER: "FETCHING_USER",
  FETCHED_USER: "FETCHED_USER",
  FETCH_USER_FAILED: "FETCH_USER_FAILED",

  EDIT_INSTITUTION: "EDIT_INSTITUTION"
};



/** WEBPACK FOOTER **
 ** ./src/actiontypes.js
 **/